import { EcoChallengeApiService } from '@/common/services/eco-challenge.api.service';
import { EcoChallengeSearchApiService } from '@/common/services/eco-challenge-search.api.service';
import { EcoChallengeModel } from '@/common/models/eco-challenge.model';
import REQUEST_STATUS from '../../common/enums/requestStatus';
import moment from "moment-timezone";

export default {
  namespaced: true,

  state: {
    status: "",
    items: [],
    item: "",
  },

  getters: {
    getAllItems: state => state.items,
    getStatus: state => state.status,
    getOrder: state => state.item,
  },

  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_ITEM(state, data) {
      state.item = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },

  actions: {
    fetchItemsList({ commit, dispatch }, { options, searchQuery, filterData }) {
      commit('FETCH_REQUEST');

      const moreFieldThanPriceAndDate = 2;

      return EcoChallengeApiService.getAll(builder => {
        builder.embed(['payload', 'status']);

        if (
          filterData &&
          (Object.keys(filterData).length > moreFieldThanPriceAndDate ||
            Object.keys(filterData.price).length ||
            Object.keys(filterData.createdAt).length)
        ) {
          if (filterData.externalId) {
            builder.whereContains(['external_id'], filterData.externalId.trim());
          }
          if (filterData.firstName) {
            builder.whereContains(['first_name'], filterData.firstName.trim());
          }
          if (filterData.lastName) {
            builder.whereContains(['last_name'], filterData.lastName.trim());
          }
          if (filterData.email) {
            builder.whereContains(['email'], filterData.email.trim());
          }
          if (filterData.createdAt) {
            if (filterData.createdAt.from) {
              builder.whereGreaterOrEqual(['created_at'], filterData.createdAt.from.trim());
            }
            if (filterData.createdAt.to) {
              builder.whereLessOrEqual(['created_at'], filterData.createdAt.to.trim());
            }
          }
          if (filterData.type && filterData.type.length) {
            builder.whereIn(['type'], filterData.type);
          }
          if (filterData.status && filterData.status.length) {
            builder.whereIn(['status'], filterData.status);
          }
        } else if (searchQuery) {
          builder.whereContains(['external_id', 'email', 'first_name', 'last_name'], searchQuery.trim());
        }

        if (options) {
          builder.getPage(options.page);
          builder.getPerPage(options.itemsPerPage);
          if (options.sortDesc && options.sortDesc[0]) {
            builder.sortBy(options.sortBy);
          } else if (options.sortBy && options.sortBy.length) {
            builder.sortByDesc(options.sortBy);
          } else {
            builder.sortByDesc([EcoChallengeModel.ATTR_CREATED_AT]);
          }
        }
      })
        .then(response => {
          const items = response.getItems();

          commit('SET_ITEMS', items);
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
          commit('FETCH_FAIL');
        });
    },

    fetchAllItems({ commit, dispatch }, { searchQuery }) {
      commit('FETCH_REQUEST');

      return EcoChallengeSearchApiService.post(null, { code: searchQuery.trim() })
        .then(response => {
          const items = response.getItems();
          commit('SET_ITEMS', items);
          if(items.length){
            commit('FETCH_SUCCESS');
          } else {
            commit('FETCH_FAIL');
          }
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    fetchOrder({ commit, dispatch }, id) {
      commit('FETCH_REQUEST');

      return EcoChallengeApiService.get(id, builder => {
        builder.embed(['eco_credits_detail', 'eco_credits', 'incorrectly_marked', 'user_email']);
      })
        .then(response => {
          commit('SET_ITEM', response.getItem());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    fetchFullOrder({ commit, dispatch }, id) {
      commit('FETCH_REQUEST');

      return EcoChallengeApiService.get(id, builder => {
        builder.embed([
          'payload',
          'status',
          'address',
          'eco_credits',
          'eco_credits_detail',
          'incorrectly_marked',
          'user_email',
          'is_first_eco_challenge',
          'invoice',
          'billing_address'
        ]);
      })
        .then(response => {
          commit('SET_ITEM', response.getItem());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    updateCredits({ commit, dispatch }, { url, formData }) {
      commit('FETCH_REQUEST');

      return EcoChallengeApiService.post(url, formData)
        .then(response => {
          commit('FETCH_SUCCESS');
          commit('SET_ITEM', response.getItem());
          this.$app.$alertSuccess(this.$app.$vuetify.lang.t('$vuetify.messages.successfulyCredits'));
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    createEco({ commit, dispatch }, { url, formData }) {
      commit('FETCH_REQUEST');

      return EcoChallengeApiService.post(url, formData)
        .then(response => {
          commit('FETCH_SUCCESS');
          commit('SET_ITEM', response.getItem());
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
